<template>
  <div>
    <div
      v-if="voorziening && accommodatie"
      class="flex flex-col m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 bg-gray-100 p-3"
    >
      <div class="flex flex-col lg:flex-row xl:flex-row">
        <div
          class="flex-grow order-2 sm:order-2 md:order-2 lg:order-1 xl:order-1"
        >
          <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
            {{ accommodatie.naam }}
          </p>
          <p class="font-opensans capitalize">
            {{ accommodatie.straat }},
            {{ accommodatie.postcode | upper }}
            {{ accommodatie.plaats["naam"] }}
          </p>
        </div>
        <div
          class="flex-grow-0 order-1 sm:order-1 md:order-1 lg:order-2 xl:order-2"
        >
          <BackToSearch />
        </div>
      </div>
      <div
        class="rounded-md my-4 bg-gray-300 w-auto p-3 font-opensans flex flex-col lg:flex-row xl:flex-row"
      >
        <div
          class="flex-grow order-2 sm:order-2 md:order-2 lg:order-1 xl:order-1"
        >
          <p class="text-grey-dark truncate">
            <a
              class="font-thin capitalize cursor-pointer"
              @click="openAccomm"
              >{{ accommodatie.naam }}</a
            >
            /
            <a href="#" class="text-mi-blue-400 font-bold"
              >Voorziening {{ voorziening.id.slice(0, 5) }}</a
            >
          </p>
        </div>
        <div
          class="hidden sm:hidden md:hidden lg:flex xl:flex xl:flex-grow-0 lg:flex-grow-0 sm:order-1 md:order-1 lg:order-2 xl:order-2"
          v-if="hasPermission('delete voorziening')"
        >
          <div class="flex flex-col ">
            <button @click="showRemove = true" class="flex justify-end">
              <i class="material-icons text-gray-500 hover:text-red-600"
                >delete</i
              >
            </button>
            <div v-if="showRemove">
              <button
                @click="removeVoorziening"
                class="bg-gray-100  text-red-700 font-semibold py-1 px-2 border border-red-600 rounded hover:bg-red-600 hover:text-white hover:border-transparent"
              >
                Ja, ik wil deze voorziening verwijderen
              </button>
              <button @click="showRemove = false">
                <i class="material-icons text-gray-500 hover:text-red-600"
                  >close</i
                >
              </button>
            </div>
          </div>
        </div>
      </div>

      <Map :acc="accommodatie" />

      <div
        class="font-raleway font-semibold text-xl text-mi-blue-500 uppercase mt-4"
      >
        Eigenschappen
      </div>
      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 grid-flow-row gap-4"
      >
        <MainPropertiesCard :vz="voorziening" />
        <SportCard :vz="voorziening" />
        <EigenaarCard
          :vz="voorziening"
          v-if="hasPermission('read ownership')"
        />
        <Flexpropcard
          v-for="card in flexpropcards"
          :key="card"
          :vzid="voorziening.id"
          :schema="voorziening.voorziening_type.flexprop_schema_current"
          :values="voorziening.flexprops ? voorziening.flexprops : {}"
          :disabled="!hasPermission('update voorziening')"
          :cardname="card"
        />
      </div>

      <div>
        <hr class="border-gray-300 border" />
      </div>

      <div
        class="font-raleway font-semibold text-xl mt-4 text-mi-blue-500 uppercase"
      >
        Opmerkingen
      </div>
      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4"
      >
        <FeedbackFormCard :objectid="this.$route.params.vzid" />
      </div>
      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4"
      >
        <FeedbackList
          :objectid="this.$route.params.vzid"
          v-if="hasPermission('read todoitem')"
        />
      </div>
    </div>

    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MainPropertiesCard from "./MainPropertiesCard";
import SportCard from "./SportCard";
import EigenaarCard from "./EigenaarCard";
import FeedbackFormCard from "../FeedbackFormCard";
import Flexpropcard from "./Flexpropcard/Flexpropcard.vue";
import FeedbackList from "../FeedbackList";
import BackToSearch from "../BackToSearch";
import Map from "./Map";

// mind: this is hairy code. Took a long time to get this running.
// There were quite some troubles in loading the voorziening when refreshing OR navigating to the voorziening.
// This has to do with how Vue reactivity works when you update an item in an array

export default {
  name: "VoorzieningHome",
  components: {
    MainPropertiesCard,
    SportCard,
    FeedbackFormCard,
    FeedbackList,
    EigenaarCard,
    Flexpropcard,
    Map,
    BackToSearch
  },
  data: function() {
    return {
      voorziening: null,
      showRemove: false
    };
  },
  created: async function() {
    await this.loadAccommodatie(this.$route.params.id);
    // Need to set voorziening empty to have a successful refresh of the page
    this.voorziening = null;
    this.loadCurrentVoorziening();
  },
  computed: {
    ...mapState({
      accommodatie: state => state.backend_data.current_accommodatie,
      voorzieningen: state => state.backend_data.voorzieningen
    }),
    flexpropcards: function() {
      const current_schema = this.voorziening.voorziening_type
        .flexprop_schema_current;
      if (!current_schema) {
        return [];
      }

      return Object.values(current_schema.properties).reduce(
        (cardnames, item) => {
          if (!cardnames.includes(item.card)) {
            cardnames.push(item.card);
          }
          return cardnames;
        },
        []
      );
    }
  },
  methods: {
    ...mapActions(["loadAccommodatie", "deleteVoorziening"]),
    loadCurrentVoorziening: function() {
      const vzid = this.$route.params.vzid;
      this.voorziening = this.voorzieningen.find(vz => vz.id === vzid);
    },
    removeVoorziening: async function() {
      const vzid = this.$route.params.vzid;

      const [ok, msg] = await this.deleteVoorziening(vzid);

      if (ok) {
        this.openAccomm();
      }
    },
    openAccomm: function() {
      this.$emit("showAccommComp");
      this.$router.push({
        name: "Accommodatie",
        params: { id: this.$route.params.id }
      });
    }
  },
  watch: {
    voorzieningen: function() {
      this.loadCurrentVoorziening();
    }
  },
  filters: {
    upper: str => str.toUpperCase()
  },
  updated() {
    this.loadCurrentVoorziening();
  },
  beforeRouteUpdate(to, from, next) {
    // this is to react to route updates
    this.voorziening = null;
    this.loadAccommodatie(to.params.id);
    next();
  }
};
</script>
